import { toMediaVariants, type MediaLike } from './toMediaVariants';

const isMediaRecord = (record: Record<string, unknown>): record is Record<string, unknown> & MediaLike => (
  typeof record.url === 'string'
  && (Object.prototype.hasOwnProperty.call(record, 'formats')
    || Object.prototype.hasOwnProperty.call(record, 'alternativeText'))
);

/**
 * Ajoute `variants` à chaque média à partir des `formats` Strapi (dev et build).
 */
export function attachMediaVariants<T>(data: T): T {
  const visit = (node: unknown): void => {
    if (!node || typeof node !== 'object') return;
    const record = node as Record<string, unknown>;
    if (isMediaRecord(record)) {
      const variants = toMediaVariants(record);
      if (variants) record.variants = variants;
    }
    Object.values(record).forEach(visit);
  };

  visit(data);
  return data;
}

/**
 * Enrichit les médias d'un loader avec des variantes responsive.
 * Les images des champs Markdown restent en <img> simple (voir plan Front, F3 abandonné).
 */
export function withMediaVariants<Args extends unknown[], Data>(
  loader: (...args: Args) => Promise<Data>,
) {
  return async (...args: Args): Promise<Data> => attachMediaVariants(await loader(...args));
}
